export enum DiplomaLevel {
    A1 = "A1",
    A2 = "A2",
    B1 = "B1",
    B2 = "B2",
    C1 = "C1"
}

export enum DiplomaDocumentType {
    CERTIFICATE = "CERTIFICATE",
    ACKNOWLEDGEMENT = "ACKNOWLEDGEMENT",
    GRADE_SHEET = "GRADE_SHEET",
    ACADEMIC_STATEMENT = "ACADEMIC_STATEMENT"
}

export enum DiplomaStatus {
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED"
}

export interface InstitutionDiplomaDto {
    diplomaLevel: DiplomaLevel;
    documentType: DiplomaDocumentType;
    documentNumber: string;
    numberOfLessons: number;
    accountName: string;
    accountSsn: string;
    institutionId: string;
    institutionName: string;
    status: DiplomaStatus;
    createdAt: string;
    createdBy?: string;
    createdByName?: string;
    senderEmail?: string;
    fileName?: string;
    extraData?: string;
}
